// extracted by mini-css-extract-plugin
export default {"main":"AuditLogsHeader_main__G644G"};